// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2GwCX","imageUploader":"EGiftCard_imageUploader__tjt6i"};